import {
  ClinicalReportDtoOrgansItem,
  ClinicalReportMaterialDto,
  ClinicalReportMaterialDtoClinicalTestMaterial,
  ClinicalReportMaterialResultDtoClinicalDetectionMethod,
  ClinicalReportMaterialResultDtoTestResult,
} from '../api/generated/model';

export function getClinicalTestMaterialName(material: ClinicalReportMaterialDtoClinicalTestMaterial) {
  switch (material) {
    case ClinicalReportMaterialDtoClinicalTestMaterial.SPUTUM:
      return 'Sputum';
    case ClinicalReportMaterialDtoClinicalTestMaterial.BRONCHIAL_SECRETION:
      return 'Bronchialsekret';
    case ClinicalReportMaterialDtoClinicalTestMaterial.OTHER:
      return 'Anderes Material';
  }
}

export function getClinicalDetectionMethodName(method: ClinicalReportMaterialResultDtoClinicalDetectionMethod) {
  switch (method) {
    case ClinicalReportMaterialResultDtoClinicalDetectionMethod.PCR:
      return 'PCR';
    case ClinicalReportMaterialResultDtoClinicalDetectionMethod.MICROSCOPY:
      return 'Mikroskopie';
    case ClinicalReportMaterialResultDtoClinicalDetectionMethod.CULTURE:
      return 'Kultur';
  }
}

export function getClinicalTestResultName(result: ClinicalReportMaterialResultDtoTestResult) {
  switch (result) {
    case ClinicalReportMaterialResultDtoTestResult.PENDING:
      return 'Ausstehend';
    case ClinicalReportMaterialResultDtoTestResult.POSITIVE:
      return 'Positiv';
    case ClinicalReportMaterialResultDtoTestResult.NEGATIVE:
      return 'Negativ';
    case ClinicalReportMaterialResultDtoTestResult.NOT_EXECUTED:
      return 'Nicht Durchgeführt';
  }
}

export function getOrganName(organ: ClinicalReportDtoOrgansItem, otherOrgan?: string | null) {
  switch (organ) {
    case ClinicalReportDtoOrgansItem.LUNG:
      return 'Lunge';
    case ClinicalReportDtoOrgansItem.PLEURA:
      return 'Pleura';
    case ClinicalReportDtoOrgansItem.UROGENITAL:
      return 'Urogenital';
    case ClinicalReportDtoOrgansItem.SPINE:
      return 'Wirbelsäule';
    case ClinicalReportDtoOrgansItem.INTRATHORACIC_LYMPH_NODES:
      return 'Intrathorakale Lymphknoten';
    case ClinicalReportDtoOrgansItem.EXTRATHORACIC_LYMPH_NODES:
      return 'Extrathorakale Lymphknoten';
    case ClinicalReportDtoOrgansItem.MENINGES:
      return 'Meningen';
    case ClinicalReportDtoOrgansItem.CNS_NON_MENINGEAL:
      return 'ZNS (nicht meningeal)';
    case ClinicalReportDtoOrgansItem.PERITONEUM_DIGECTIVE_TRACT:
      return 'Peritoneum/Verdauungstrakt';
    case ClinicalReportDtoOrgansItem.BONES_SKELETON_JOINTS:
      return 'Knochen/Skelett/Gelenke';
    case ClinicalReportDtoOrgansItem.DISSEMINATED_FORM:
      return 'Disseminierte Form';
    case ClinicalReportDtoOrgansItem.OTHER:
      return otherOrgan ?? 'Andere';
  }
}

export function getTbType(organs: ClinicalReportDtoOrgansItem[]) {
  if (organs.includes(ClinicalReportDtoOrgansItem.LUNG)) {
    return 'PTB';
  }
  if (organs.length > 0) {
    return 'EPTB';
  }
}

export function getClinicalMaterialSummaryStrings(materials: ClinicalReportMaterialDto[]) {
  return (materials ?? []).flatMap((material) => {
    const materialName =
      material.clinicalTestMaterial === ClinicalReportMaterialDtoClinicalTestMaterial.OTHER
        ? material.otherMaterial
        : getClinicalTestMaterialName(material.clinicalTestMaterial);

    return material.clinicalReportMaterialResults.map(
      (result) =>
        `${materialName} | ${getClinicalDetectionMethodName(result.clinicalDetectionMethod)} | ${getClinicalTestResultName(result.testResult)}`,
    );
  });
}
